module.exports = __webpack_public_path__ + "static/e-illu-5-c7ee02865a72b2e58fdc0f24c0973a23.png";